import { BaseReducer } from '@hobs/utils/baseReducer';
import {
  FORSUBMIT,
  GET_INVOICE,
  CLEAR_INVOICE
} from '@hobs/constants/invoices';

class Invoices extends BaseReducer {
  static defaultState = {
    forSubmit: null,
    invoices: null
  };
  constructor() {
    super(Invoices.defaultState);

    this.actionMap = {
      [GET_INVOICE.SUCCESS]: this.addInvoice,
      [FORSUBMIT.SUCCESS]: this.getForSubmit,
      [CLEAR_INVOICE.SUCCESS]: this.clearInvoice
    };
  }

  getForSubmit = (state, action) => {
    return Object.assign({}, state, {
      forSubmit: action.response
    });
  };

  addInvoice = (state, action) => {
    return Object.assign({}, state, {
      invoices: action.response.invoiceReferences || action.response
    });
  };

  clearInvoice = state => {
    return Object.assign({}, state, { invoices: null, forSubmit: null });
  };
}
export default new Invoices().reducer;
